import { useState } from "react";
import { API_BASE_URL } from '../../config/api.js';
import { Link } from "react-router-dom";
import styles from "../../styles/Auth.module.css";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const setValidity = (e, msg) => e.target.setCustomValidity(msg || "");
  const clearValidity = (e) => e.target.setCustomValidity("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      // Wywołanie endpointu resetowania hasła na backendzie
      const res = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error('Błąd resetowania hasła');
      setMessage("Jeśli konto istnieje, wysłaliśmy instrukcję resetowania hasła na podany email.");
    } catch (err) {
      setError("Błąd resetowania hasła. Spróbuj ponownie.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authBg}>
      <div className={styles.mainContent}>
        <Link to="/">
          <img src="/logo2.png" alt="Paperly logo" className={styles.authLogoStandalone} />
        </Link>
        <form onSubmit={onSubmit} className={styles.authForm} autoComplete="on" aria-label="Resetowanie hasła">
          <div className={styles.authHeader}>
            <h1 className={styles.authTitle}>Resetuj hasło</h1>
            <p className={styles.authSubtitle}>Podaj email, a my wyślemy Ci link do zmiany hasła.</p>
          </div>

          {!message && (
            <div className={styles.inputGroup}>
              <input
                id="email"
                value={email}
                onChange={(e) => { clearValidity(e); setEmail(e.target.value); }}
                onInvalid={(e) => setValidity(e, "Wpisz poprawny adres e‑mail.")}
                type="email"
                required
                className={styles.inputField}
                autoFocus
                autoComplete="email"
                placeholder=" "
              />
              <label htmlFor="email" className={styles.inputLabel}>Adres e-mail</label>
            </div>
          )}

          {error && <div className={styles.authError}>{error}</div>}
          {message && <div className={styles.authSuccess}>{message}</div>}

          {!message && (
            <button type="submit" className={styles.authButton} disabled={loading}>
              {loading ? "Wysyłanie..." : "Wyślij instrukcję"}
            </button>
          )}

          <div className={styles.authFooter}>
            <Link to="/login" className={styles.authLink}>Powrót do logowania</Link>
          </div>
        </form>
      </div>
      <footer className={styles.authPageFooter}>
        <Link to="/" className={styles.authPageFooterLink}>Strona główna</Link>
        <span className={styles.authPageFooterSeparator}>•</span>
        <Link to="/polityka-prywatnosci" className={styles.authPageFooterLink}>Polityka Prywatności</Link>
        <span className={styles.authPageFooterSeparator}>•</span>
        <Link to="/regulamin" className={styles.authPageFooterLink}>Regulamin</Link>
      </footer>
    </div>
  );
}